import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-xl mx-auto text-center py-32 px-4">
      <p className="font-caption text-brass text-xs mb-3">Not in the ledger</p>
      <h1 className="font-display text-5xl text-gold mb-4">This corner is quiet</h1>
      <p className="text-parchment/70 italic mb-8">The page you're seeking hasn't been catalogued yet — or has wandered off.</p>
      <Link to="/" className="btn-outline">Return to the Market</Link>
    </div>
  );
}
